import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar20 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2004 4.19922H2.80039V3.03022C2.80039 2.90352 2.91309 2.80202 3.04189 2.79922H4.20039V3.49922H5.60039V2.79922H8.40039V3.49922H9.80039V2.79922H10.9442C11.0877 2.80202 11.2004 2.90352 11.2004 3.03022V4.19922ZM11.2004 10.9626C11.2004 11.0998 11.0982 11.1992 10.9582 11.1992H3.04189C2.90189 11.1992 2.80039 11.0998 2.80039 10.9626V5.59922H11.2004V10.9626ZM10.9582 1.39922H9.80039V0.699219H8.40039V1.39922H5.60039V0.699219H4.20039V1.39922H3.02789C2.11509 1.41742 1.40039 2.13422 1.40039 3.03022V10.9626C1.40039 11.8803 2.12139 12.5992 3.04189 12.5992H10.9582C11.8794 12.5992 12.6004 11.8803 12.6004 10.9626V3.03022C12.6004 2.13422 11.8857 1.41742 10.9582 1.39922Z",
		fill: "currentColor",
		fillOpacity: .87
	})]
});
const ForwardRef = forwardRef(SvgCalendar20);
export { ForwardRef as ReactComponent };
